/**
 * <omi-variant-sync data-sync="key">: replaces its contents with the element carrying the
 * same data-sync key in the section HTML that Horizon fetches when the variant changes.
 * Outside the product section (no fresh copy in that HTML), rows marked data-variant-id
 * are highlighted for the newly selected variant instead, and elements marked data-sync-group are
 * shown only when they share the selected variant's group.
 */
const PRODUCT_SELECT = 'shopify:product:select';

class OmiVariantSync extends HTMLElement {
  connectedCallback() {
    document.addEventListener(PRODUCT_SELECT, this.#onSelect);
  }

  disconnectedCallback() {
    document.removeEventListener(PRODUCT_SELECT, this.#onSelect);
  }

  /** @param {any} event */
  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    Promise.resolve(event.promise)
      .then((result) => {
        const html = result?.detail?.html;
        if (!html) return;
        const fresh = html.querySelector(`omi-variant-sync[data-sync="${this.dataset.sync}"]`);
        if (fresh) {
          this.innerHTML = fresh.innerHTML;
          return;
        }
        const variantId = String(result?.detail?.resource?.id ?? new URL(window.location.href).searchParams.get('variant') ?? '');
        if (!variantId) return;
        // Show only the elements in the selected variant's group (e.g. its comfort's size rows, or its size's link)
        const chosen = /** @type {HTMLElement | null} */ (this.querySelector(`[data-variant-id="${variantId}"]`));
        const group = chosen?.dataset.syncGroup;
        if (group !== undefined) {
          for (const el of this.querySelectorAll('[data-sync-group]')) {
            /** @type {HTMLElement} */ (el).hidden = /** @type {HTMLElement} */ (el).dataset.syncGroup !== group;
          }
        }
        for (const row of this.querySelectorAll('tr[data-variant-id], [data-variant-id]:not([data-sync-group])')) {
          const on = /** @type {HTMLElement} */ (row).dataset.variantId === variantId;
          row.classList.toggle('is-selected', on);
          if (on) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        }
      })
      .catch(() => {});
  };
}

if (!customElements.get('omi-variant-sync')) customElements.define('omi-variant-sync', OmiVariantSync);
